module.exports = __webpack_public_path__ + "static/media/skye.3db66973.png";